import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Divider from '@mui/material/Divider';
import axios from 'axios';
import IconButton from '@mui/material/IconButton';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    maxWidth: '1200px',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
    overflow: 'auto',
    maxHeight: '90vh',
};

const styleImageModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
    maxWidth: '90%',
    maxHeight: '90%',
};

export default function ModalDetalleProducto({ producto }) {
    const [open, setOpen] = useState(false);
    const [openImageModal, setOpenImageModal] = useState(false);
    const [imageSrc, setImageSrc] = useState('');
    const [historial, setHistorial] = useState([]);
    const [especificaciones, setEspecificaciones] = useState([]);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const handleImageClick = (src) => {
        setImageSrc(src);
        setOpenImageModal(true);
    };
    const handleCloseImageModal = () => setOpenImageModal(false);

    useEffect(() => {
        if (open) {
            getHistorial();
            getEspecificaciones();
        }
    }, [open]);

    const getHistorial = async () => {
        try {
            const response = await axios.post(
                'https://invio.datachile.site/Web/Productos/ObtenerHistorialProducto.php',
                { id_producto: producto }
            );
            setHistorial(response.data);
        } catch (error) {
            console.error('Error al obtener el historial del producto:', error);
        }
    };

    const getEspecificaciones = async () => {
        try {
            const response = await axios.post(
                'https://invio.datachile.site/Web/Productos/ObtenerEspecificaciones.php',
                { id_producto: producto }
            );
            setEspecificaciones(response.data);
        } catch (error) {
            console.error('Error al obtener las especificaciones del producto:', error);
        }
    };

    return (
        <div>
            <IconButton color="primary" onClick={handleOpen}>
                <ManageSearchIcon />
            </IconButton>

            {/* Modal principal */}
            <Modal open={open} onClose={handleClose} aria-labelledby="modal-title">
                <Box sx={style}>
                    <Typography id="modal-title" variant="h6" gutterBottom>
                        Historial del Producto
                    </Typography>

                    <Divider sx={{ mb: 2 }} />

                    {especificaciones.length > 0 && (
                        <div style={{ marginBottom: '20px' }}>
                            <Typography variant="h6">Especificaciones</Typography>
                            <ul>
                                {especificaciones.map((espec) => (
                                    <li key={espec.idEspecificacion}>
                                        <strong>{espec.especificacion}:</strong> {espec.detalle}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}

                    {historial.length > 0 ? (
                        <TableContainer component={Paper} sx={{ overflowX: 'auto' }}>
                            <Table sx={{ minWidth: 800 }}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Imagen</TableCell>
                                        <TableCell>Fecha</TableCell>
                                        <TableCell>Estado</TableCell>
                                        <TableCell>Categoría</TableCell>
                                        <TableCell>Ubicación</TableCell>
                                        <TableCell>Código</TableCell>
                                        <TableCell>Mapa</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {historial.map((hproducto) => (
                                        <TableRow key={hproducto.idH_producto}>
                                            <TableCell>
                                                <img
                                                    src={hproducto.foto}
                                                    alt="Producto"
                                                    style={{
                                                        width: '50px',
                                                        height: '50px',
                                                        borderRadius: '5px',
                                                        cursor: 'pointer',
                                                    }}
                                                    onClick={() => handleImageClick(hproducto.foto)}
                                                />
                                            </TableCell>
                                            <TableCell>{hproducto.hfecha_producto}</TableCell>
                                            <TableCell>{hproducto.estado}</TableCell>
                                            <TableCell>{hproducto.categoria}</TableCell>
                                            <TableCell>{hproducto.lugar}</TableCell>
                                            <TableCell>{hproducto.epc}</TableCell>
                                            <TableCell>
                                                <a
                                                    href={`https://www.google.com/maps/place/${hproducto.latitud},${hproducto.longitud}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    Ver en mapa
                                                </a>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    ) : historial.length === 1 ? (
                        <Card sx={{ display: 'flex', mb: 2 }}>
                            <CardMedia
                                component="img"
                                sx={{ width: 150 }}
                                image={historial[0]?.foto}
                                alt="Producto"
                            />
                            <CardContent>
                                <Typography variant="h6">{historial[0]?.hfecha_producto}</Typography>
                                <Typography variant="body2">
                                    <strong>Estado:</strong> {historial[0]?.estado}<br />
                                    <strong>Categoría:</strong> {historial[0]?.categoria}<br />
                                    <strong>Ubicación:</strong> {historial[0]?.lugar}<br />
                                    <strong>Código:</strong> {historial[0]?.epc}<br />
                                    <strong>Mapa:</strong>{' '}
                                    <a
                                        href={`https://www.google.com/maps/place/${historial[0]?.latitud},${historial[0]?.longitud}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Click para ver
                                    </a>
                                </Typography>
                            </CardContent>
                        </Card>
                    ) : (
                        <Typography variant="body1">No hay historial disponible.</Typography>
                    )}
                </Box>
            </Modal>

            {/* Modal de imagen ampliada */}
            <Modal open={openImageModal} onClose={handleCloseImageModal}>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '100vh',
                        width: '100vw',
                        outline: 'none',
                    }}
                >
                    <img
                        src={imageSrc}
                        alt="Imagen ampliada"
                        style={{
                            maxWidth: '90%',
                            maxHeight: '90%',
                            borderRadius: '10px',
                            boxShadow: '0 0 15px rgba(0,0,0,0.3)',
                        }}
                    />
                </Box>
            </Modal>

        </div>
    );
}
